
import { Box, Popover, Typography, Skeleton, useTheme, Tooltip } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFreeTablesData, setIsBackToHoreca, updateReservationGroup, updateTime,
} from "../../store/slice/Addguest.slice";
import { getFreeTables } from "../../api/HorecaWidget.service";
import dayjs from "dayjs";
import { useWidgetHeight } from "./widgetHeightContext";

const TimeComponent = ({ isOpen, handleClose, Ref }) => {
  const { css } = useSelector((store) => store?.widgetSettings);
  const timeCss = css?.find((item) => item?.cssTabFieldsGroupName === "Time")?.fields;
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { onPopoverClose } = useWidgetHeight();

  const {
    reservType, selectedDate, totalCount, time,
    freeTablesData, reservGroup, isBackToHoreca, languageWords, defaultLanguage,
  } = useSelector((store) => store?.addGuest);

  const { WidgetSetting, key } = useSelector((store) => store?.widgetSettings);
  const widgetMinTimeBeforeArrival = WidgetSetting?.find((i) => i?.tag === "widgetMinTimeBeforeArrival");
  const { defaultLang } = useSelector((store) => store?.Combination);

  const [anchorOriginVert,    setAnchorOriginVert]    = useState("bottom");
  const [transformOriginVert, setTransformOriginVert] = useState("top");


  const getTimeDetails = useCallback(async () => {
    setIsLoading(true);
  
    const formattedDate = dayjs(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD");
  
    const payload = {
      idreservationtype: parseInt(reservType.idreservationtype) ?? 0,
      duration: parseInt(reservType?.duration) ?? 0,
      durationgroups: parseInt(reservType?.durationgroups) ?? 0,
      bookableupto:
        reservType?.bookableupto?.HasValue && reservType?.bookableupto > 0
          ? parseInt(reservType?.bookableupto.Value)
          : parseInt(reservType.duration) ?? 0,
      date: formattedDate,
      totalpersons: parseInt(totalCount),
      key,
      addTime: parseInt(widgetMinTimeBeforeArrival?.data),
      lang: defaultLang || defaultLanguage,
      reservationRequestMin: 22,
    };
  
    try {
      const response = await getFreeTables(payload);
      if (response?.status !== 200 || !response?.data)
        throw new Error("No free tables found");
  
      dispatch(setFreeTablesData(response?.data));
    } catch (error) {
      console.log("error fetching get time details:", error?.message);
    } finally {
      setIsLoading(false);
    }
  }, [
    selectedDate,
    reservType,
    totalCount,
    key,
    widgetMinTimeBeforeArrival,
    defaultLang,
    defaultLanguage,
    dispatch,
  ]);

  useEffect(() => {
    if (Object.keys(reservType).length > 0 && !isBackToHoreca) {
      getTimeDetails();
    }
  }, [reservType, isBackToHoreca, getTimeDetails]);
  useEffect(() => {
    if (Ref.current) {
      const rect = Ref.current.getBoundingClientRect();
      if (rect.bottom + 400 > window.innerHeight) {
        setAnchorOriginVert("top"); setTransformOriginVert("bottom");
      } else {
        setAnchorOriginVert("bottom"); setTransformOriginVert("top");
      }
    }

  }, [isOpen, Ref]);

  const isDisabled = (item) => item?.locked || (item?.count > 0 && totalCount > item?.count);

  return (
    <Popover
      open={isOpen} anchorEl={Ref?.current}
      onClose={() => {onPopoverClose(); handleClose() }}
      anchorOrigin={{ vertical: anchorOriginVert, horizontal: "center" }}
      transformOrigin={{ vertical: transformOriginVert, horizontal: "center" }}
    
      PaperProps={{
        sx: {
          overflowY: "auto", scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          maxHeight: 420, width: { xs: "92vw", md: "400px" ,lg:'550px' },
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)", borderRadius: "8px",
        },
      }}
      disableAutoFocus disableEnforceFocus disableRestoreFocus
    >
      <Box sx={{ width: { xs: "100%" }, backgroundColor: timeCss?.TimesBackgroundColor || "#fff", p: { xs: 1.5, sm: 2 } }}>
        <Typography sx={{ color: theme?.time?.itemTextColor, fontSize: "13px", fontWeight: 700, mb: 1.25, letterSpacing: "0.02em" }}>
          {languageWords?.labelSelectTime}
        </Typography>
        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: { xs: "6px", sm: "8px" }, width: "100%" }}>
          {isLoading
            ? Array.from({ length: 9 }).map((_, i) => (
                <Box key={i} sx={{ height: { xs: "36px", sm: "40px" }, border: "1px solid #e0e0e0", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px" }}>
                  <Skeleton variant="text" width={44} height={22} />
                </Box>
              ))
            : freeTablesData?.map((item, index) => {
                const disabled = isDisabled(item);
                const isSelected = time === item?.time;
                return (
                  <Tooltip key={index} title={disabled ? item?.lockedAlert : ""} arrow disableHoverListener={!disabled}>
                    <Box
                      sx={{
                        height: { xs: "36px", sm: "40px" },
                        border: "1px solid",
                        borderColor: isSelected ? timeCss?.TimesTimeBackgroundColorActive || "#e8793a" : timeCss?.TimesTimeBorderColor || "#ddd",
                        display: "flex", justifyContent: "center", alignItems: "center",
                        cursor: disabled ? "not-allowed" : "pointer",
                        transition: "background-color 0.2s ease, border-color 0.2s ease",
                        borderRadius: "5px",
                        backgroundColor: isSelected ? timeCss?.TimesTimeBackgroundColorActive || "#e8793a" : timeCss?.TimesTimeBackgroundColor || "transparent",
                        color: isSelected ? timeCss?.TimesTimeTextColorActive || "#fff" : timeCss?.TimesTimeTextColor || "#333",
                        textDecoration: disabled ? "line-through" : "none",
                        opacity: disabled ? 0.45 : 1,
                        "&:hover": !disabled ? { backgroundColor: timeCss?.TimesTimeBackgroundColorHover || "#f5f5f5" } : {},
                      }}
                      onClick={() => {
                        if (disabled) return;
                        if (reservGroup && Object.keys(reservGroup).length > 0) dispatch(updateReservationGroup({}));
                        dispatch(setIsBackToHoreca(false));
                        dispatch(updateTime(item.time));
                        onPopoverClose();
                        handleClose();
                      }}
                    >
                      <Typography className="time-text" sx={{ fontSize: { xs: "12px", sm: "13px" }, fontWeight: isSelected ? 600 : 400, lineHeight: 1, color: "inherit" }}>
                        {item?.time.substring(0, 5)}
                      </Typography>
                    </Box>
                  </Tooltip>
                );
              })}
        </Box>
      </Box>
    </Popover>
  );
};

export default TimeComponent;

